import React from "react";
import { NavLink } from "react-router-dom";
import "./sideDrawer.css";

const sideDrawer = props => {
  let drawerClasses = "side-drawer";
  if (props.show) {
    drawerClasses = "side-drawer open";
  }
  return (
    <div className={drawerClasses}>
      <ul>
        <li>
          <NavLink to="/conversion/area" className={({ isActive }) => isActive ? "active" : ""}>
            <i className="fa fa-expand"></i>
            Area Conversion
          </NavLink>
        </li>
        <li>
          <NavLink to="/conversion/length" className={({ isActive }) => isActive ? "active" : ""}>
            <i className="fa fa-arrows-h"></i>
            Length Conversion
          </NavLink>
        </li>
        <li>
          <NavLink to="/conversion/speed" className={({ isActive }) => isActive ? "active" : ""}>
            <i className="fa fa-tachometer"></i>
            Speed Conversion
          </NavLink>
        </li>
        <li>
          <NavLink to="/conversion/temperature" className={({ isActive }) => isActive ? "active" : ""}>
            <i className="fa fa-thermometer-half"></i>
            Temperature Conversion
          </NavLink>
        </li>
        <li>
          <NavLink to="/conversion/time" className={({ isActive }) => isActive ? "active" : ""}>
            <i className="fa fa-clock-o"></i>
            Time Conversion
          </NavLink>
        </li>
        <li>
          <NavLink to="/conversion/volume" className={({ isActive }) => isActive ? "active" : ""}>
            <i className="fa fa-cube"></i>
            Volume Conversion
          </NavLink>
        </li>
        <li>
          <NavLink to="/conversion/weight" className={({ isActive }) => isActive ? "active" : ""}>
            <i className="fa fa-balance-scale"></i>
            Weight Conversion
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default sideDrawer;
